import { ISeasonAward } from '../../admin/seasonAwards/store';

export interface ISeasonAwardsStore {
  [seasonId: number]: {
    [userId: number]: ISeasonAward[];
  };
}

export const seasonAwardsStore: ISeasonAwardsStore = {};
